import React from 'react';

import { ROLES } from '../../constants';
import FiltersSelectContent from '../FiltersSelectContent';

interface FiltersRolesProps {
  type: string;
}

const FiltersRoles: React.FC<FiltersRolesProps> = ({ type }) => <FiltersSelectContent type={type} items={ROLES} />;
export default FiltersRoles;
